import React from 'react';
import './FormBackButton.css';

export default function FormBackButton({ onClick, ariaLabel = 'Voltar' }) {
  return (
    <button
      type="button"
      className="form-back-button"
      onClick={onClick}
      aria-label={ariaLabel}
    >
      <svg viewBox="0 0 24 24" fill="none" className="form-back-button__icon" aria-hidden="true">
        <polyline
          points="15 18 9 12 15 6"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <span>Voltar</span>
    </button>
  );
}
